import { Injectable } from "@angular/core";
import { BrowserAgent } from "@newrelic/browser-agent/loaders/browser-agent";

export interface NewRelicInitMetaData {
  practiceId: string;
  deviceId?: string;
  patientId?: string;
  siteId?: string;
  domain?: string;
}

@Injectable({ providedIn: "root" })
export class NewRelicAgentFactory {
  create(config: any): BrowserAgent {
    return new BrowserAgent(config);
  }
}

@Injectable({
  providedIn: "root",
})
export class NewRelicService {
  constructor(private _agentFactory: NewRelicAgentFactory) {}

  private _browserAgent: BrowserAgent;

  public setUserId(userId: string): void {
    if (this._browserAgent) {
      this._browserAgent.setUserId(userId);
    }
  }

  public setCustomAttribute(name: string, value: string, persist: boolean = false): void {
    if (this._browserAgent) {
      this._browserAgent.setCustomAttribute(name, value, persist);
    }
  }

  public init(metaData: NewRelicInitMetaData): void {
    const { deviceId, practiceId, patientId, siteId, domain } = metaData;

    const options = {
      init: {
        session_replay: {
          enabled: false,
          block_selector: "",
          mask_text_selector: "*",
          sampling_rate: 10.0,
          error_sampling_rate: 100.0,
          mask_all_inputs: true,
          collect_fonts: true,
          inline_images: false,
          inline_stylesheet: true,
          fix_stylesheets: true,
          preload: false,
          mask_input_options: {},
        },
        distributed_tracing: { enabled: true },
        privacy: { cookies_enabled: true },
        ajax: { deny_list: ["bam.eu01.nr-data.net"] },
      },
      info: { beacon: "bam.eu01.nr-data.net", errorBeacon: "bam.eu01.nr-data.net", licenseKey: "NRJS-2685bb1c797511cfeb9", applicationID: "538575980", sa: 1 },
      loader_config: { accountID: "3034779", trustKey: "2582370", agentID: "538575980", licenseKey: "NRJS-2685bb1c797511cfeb9", applicationID: "538575980" },
    };

    this._browserAgent = this._agentFactory.create(options);

    for (const [key, value] of Object.entries({
      practice_id: practiceId,
      device_id: deviceId,
      site_id: siteId,
      domain: domain,
      patient_id: patientId,
    })) {
      if (value) {
        this.setCustomAttribute(key, value);

        if (key === "device_id") {
          this.setUserId(value);
        }
      }
    }
  }

  public get browserAgent(): BrowserAgent {
    return this._browserAgent;
  }
}
